<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<el-button @click="addUser" type="primary">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" border stripe style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="组织" prop="client_name" width="200"></el-table-column>
				<el-table-column label="地图名" prop="name" width="200"></el-table-column>
				<el-table-column label="楼层" prop="level" width="80" align="center"></el-table-column>
				<el-table-column label="类型" prop="type" width="100">
					<template #default="scope">{{ scope.row.type == 2 ? '2D' : '3D' }}</template>
				</el-table-column>
				<el-table-column label="地图类型" prop="map_type" width="120">
					<template #default="scope">{{ scope.row.map_type == 2 ? '平面地图' : '蜂鸟' }}</template>
				</el-table-column>
				<el-table-column label="设备类型" prop="type_id" width="120">
					<template #default="scope">{{ typeIdLabel(scope.row.type_id) }}</template>
				</el-table-column>
				<el-table-column label="地图图片" width="120">
					<template #default="scope">
						<a v-if="scope.row.map_image" :href="scope.row.map_image" target="_blank">
							<img :src="scope.row.map_image" :alt="scope.row.name"
								style="width:80px;height:60px;object-fit:contain;cursor:pointer" />
						</a>
						<span v-else class="muted">-</span>
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" width="100">
					<template #default="scope">{{ scope.row.status == 2 ? '停用' : '可用' }}</template>
				</el-table-column>
				<el-table-column label="创建时间" prop="create_at" width="180"></el-table-column>
				<el-table-column label="设备定位" width="150">
					<template #default="scope">
						<el-button @click="handleViewLocation(scope.row)" type="primary" size="small">查看</el-button>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="200">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small">编辑</el-button>
						<el-button @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :current-page="formInline.page" :page-size="formInline.size"
				:page-sizes="[10, 20, 50]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑" top="30vh" v-model="addPop" width="40%">
				<el-form :model="addForm" ref="addForm" :rules="rules" label-width="120px">
					<el-form-item label="组织" prop="client_id">
						<el-cascader :options="clientOpts" placeholder="请选择组织" v-model="addForm.client_id"
							style="width:100%"></el-cascader>
					</el-form-item>
					<el-form-item label="地图名" prop="name">
						<el-input v-model="addForm.name" placeholder="请输入地图名"></el-input>
					</el-form-item>
					<el-form-item label="楼层" prop="level">
						<el-input v-model="addForm.level" placeholder="请输入楼层（纯数字）" @input="onLevelInput"></el-input>
					</el-form-item>
					<el-form-item label="类型" prop="type">
						<el-radio-group v-model="addForm.type">
							<el-radio :label="2">2D</el-radio>
							<el-radio :label="3">3D</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="地图类型" prop="map_type">
						<el-radio-group v-model="addForm.map_type">
							<el-radio :label="1">蜂鸟</el-radio>
							<el-radio :label="2">平面地图</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="设备类型" prop="type_id">
						<el-select v-model="addForm.type_id" placeholder="请选择设备类型" clearable
							style="width:100%">
							<el-option v-for="item in typeOptions" :key="item.id"
								:label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="地图图片">
						<el-upload action="/common/upload" :on-success="handleMapImageUpload" :show-file-list="false"
							accept="image/*">
							<el-button type="primary">上传图片</el-button>
						</el-upload>
						<a v-if="addForm.map_image" :href="addForm.map_image" target="_blank"
							class="el-button el-button--text" style="margin-left:10px;">查看</a>
						<img v-if="addForm.map_image" :src="addForm.map_image"
							style="width:80px;height:60px;object-fit:contain;margin-left:10px;vertical-align:middle" />
						<el-button v-if="addForm.map_image" type="danger" link size="small"
							style="margin-left:10px;" @click="addForm.map_image = ''">清除</el-button>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import deviceMap from "../../model/deviceMap";
	import client from "../../model/client";
	import goods from "../../model/goods";
	import { buildClientOptions, findClientPath } from "../../utils/clientCascader";

	export default {
		name: "deviceMap",
		data() {
			return {
				appData: [],
				listCount: 0,
				// 设备类型选项（型号列表，来自 deviceModel/selectList，value=device_model.id 与 device.type_id 一致）
				typeOptions: [],
				formInline: {
					page: 1,
					size: 10
				},
				addPop: false,
				clientOpts: [],
			addForm: {
				id: 0,
				client_id: [],
				name: "",
				level: "0",
				map_image: "",
				map_type: 1,
				type: 3,
				status: 1,
				type_id: 0,
			},
				rules: {
					client_id: [{
						required: true,
						message: '请选择组织',
						trigger: "change"
					}],
					name: [{
						required: true,
						message: '请输入地图名',
						trigger: "blur"
					}],
					type: [{
						required: true,
						message: '请选择类型',
						trigger: "change"
					}],
					level: [{
						validator: (rule, value, callback) => {
							if (value === '' || value === null || value === undefined) {
								callback();
								return;
							}
							if (!/^\d+$/.test(String(value))) {
								callback(new Error('楼层只能填写数字'));
								return;
							}
							callback();
						},
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			await this.loadClient();
			await this.loadTypes();
		},
		methods: {
			async loadData() {
				const ret = await deviceMap.list({
					page: this.formInline.page,
					size: this.formInline.size
				});
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.formInline.page = 1;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					this.clientOpts = buildClientOptions(ret.data);
				}
			},
			// 型号列表（复用 goods/lists 页的型号数据源）
			async loadTypes() {
				const ret = await goods.getModelList({ size: 10000 });
				if (ret.code === 200) {
					this.typeOptions = ret.data.list || [];
				}
			},
			addUser() {
				this.addPop = true;
				this.addForm = {
					id: 0,
					client_id: [],
					name: "",
					level: "0",
					map_image: "",
					map_type: 1,
					type: 3,
					status: 1,
					type_id: 0,
				};
			},
			// 楼层只允许纯数字
			onLevelInput(val) {
				this.addForm.level = String(val == null ? '' : val).replace(/\D/g, '');
			},
			handleEdit(row) {
				this.addPop = true;
				const rowData = JSON.parse(JSON.stringify(row));
				this.addForm = {
					id: rowData.id,
					client_id: findClientPath(this.clientOpts, rowData.client_id) || [rowData.client_id],
					name: rowData.name,
					level: rowData.level == null ? "0" : String(rowData.level),
					map_image: rowData.map_image || "",
					map_type: rowData.map_type,
					type: rowData.type,
					status: rowData.status,
					type_id: Number(rowData.type_id || 0),
				};
			},
			// 设备类型显示名（type_id 对应 device_model.id）
			typeIdLabel(value) {
				const item = this.typeOptions.find(m => Number(m.id) === Number(value));
				return (item && item.name) || '-';
			},
			// 地图图片上传成功回调
			handleMapImageUpload(response) {
				if (response && response.code === 200) {
					this.addForm.map_image = response.data;
				} else {
					this.$message.error((response && response.message) || '上传失败');
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm));
						// 组织取级联最后一级
						params.client_id = Array.isArray(params.client_id) ? params.client_id.pop() : params.client_id;
						// 楼层为整数，空值回落 0
						params.level = (params.level === '' || params.level === null || params.level === undefined) ? 0 : Number(params.level);
						const ret = await deviceMap.save(params);
						if (ret.code === 200) {
							this.addPop = false;
							this.$message.success(ret.message);
							this.loadData();
						} else {
							this.$message.warning(ret.message);
						}
					}
				});
			},
			handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
					confirmButtonText: this.$t('device.confirm'),
					cancelButtonText: this.$t('device.cancel'),
					type: "warning"
				}).then(async () => {
					const ret = await deviceMap.delete({
						id: row.id
					});
					if (ret.code === 200) {
						this.$message.success('操作成功');
						this.loadData();
					} else {
						this.$message.error(ret.message);
					}
				}).catch(() => {});
			},
			handleViewLocation(row) {
				const path = row.map_type == 2 ? '/fmap/flat' : '/fmap/lists';
				this.$router.push({
					path: path,
					query: {
						map_id: row.id,
						client_id: row.client_id,
						name: row.name,
						type_id: row.type_id || ''
					}
				});
			}
		}
	};
</script>
<style scoped>
	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 20px 0px;
		float: right;
	}

	.muted {
		color: #909399;
	}
</style>
